<section>
  <app-breadcrumb [label]="titleOfBreadcrumb"></app-breadcrumb>

  <div class="section__main section__main--commissions">
    <div class="section__title section__title--mb">
      <h1>
        Comisiones por marca
      </h1>
    </div>

    <div class="commission__block">
      <p-accordion class="w-full" [activeIndex]="0" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
        <p-accordionTab *ngFor="let brand of commissionsList" iconPos="end">
          <ng-template pTemplate="header">
            <div class="accordion-header">
              <i class="pi pi-mobile"></i>
              <span>{{ brand.brand.name }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <p-table [value]="brand.brand.price_ranges" styleClass="p-datatable">
              <ng-template pTemplate="header">
                <tr>
                  <th>Rango de precio</th>
                  <th>Comisión</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-range>
                <tr>
                  <td>
                    <div class="datatable__info">
                      <div class="datatable__infoText">
                        <p>{{ getFormattedPriceRange(range)}}</p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="datatable__value">
                      <p>{{range.commission | currency}}</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-template>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</section>